<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <gx-date-range-select
        	style="margin-right:8px;"
          :date-range.sync="dateRange"
          :disabled="isLoading"
          @selectedDateRange="handleSelectedDateRange"
        />

        <el-button
          type="primary"
          size="mini"
          @click="handleShow"
        >
          Show
        </el-button>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="records"
      border
      show-summary
    >
      <el-table-column
        label="Year"
        prop="year"
        min-width="60"
      />

      <el-table-column
        label="Month"
        prop="month"
        min-width="60"
      />

      <el-table-column label="Facebook">
	      <el-table-column
	        label="Spendings"
	        prop="facebook_sum_spend"
	        min-width="80"
	      />

	      <el-table-column
	        label="Impressions"
	        prop="facebook_sum_impression"
	        min-width="80"
	      />

	      <el-table-column
	        label="Clicks"
	        prop="facebook_sum_click"
	        min-width="80"
	      />
	    </el-table-column>

	    <el-table-column label="Google">
	      <el-table-column
	        label="Spendings"
	        prop="google_sum_spend"
	        min-width="80"
	      />

	      <el-table-column
	        label="Impressions"
	        prop="google_sum_impression"
	        min-width="80"
	      />

	      <el-table-column
	        label="Clicks"
	        prop="google_sum_click"
	        min-width="80"
	      />
	    </el-table-column>

	    <el-table-column label="Total">
	      <el-table-column
	        label="Spending"
	        prop="total_spend"
	        min-width="80"
	      />

	      <el-table-column
	        label="Impressions"
	        prop="total_impression"
	        min-width="80"
	      />

	      <el-table-column
	        label="Clicks"
	        prop="total_click"
	        min-width="80"
	      />
     	</el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import format from 'date-fns/format'
import { getAdPerformance } from '../../api/reports'

export default {
  name: 'AdPerformanceReport',
  data() {
    return {
      isLoading: false,
      dateRange: { value: 'thisMonth', label: 'This Month' },
      dateRangeOptions: [
        { value: 'lastSevenDays', label: 'Last 7 Days' },
        { value: 'thisWeek', label: 'This Week' },
        { value: 'lastWeek', label: 'Last Week' },
        { value: 'thisMonth', label: 'This Month' },
        { value: 'lastMonth', label: 'Last Month' },
        { value: 'lastThirtyDays', label: 'Last 30 Days' },
        { value: 'custom', label: 'Custom' },
      ],
      customDateRange: [],
      records: [],
    }
  },
  methods: {
  	handleSelectedDateRange(dateRange) {
      this.customDateRange = dateRange
    },
    handleShow() {
      this.getRecords(this.year, this.month)
    },
    async getRecords(year, month) {
      this.isLoading = true

      const startDate = (this.customDateRange[0]) ? format(this.customDateRange[0], 'yyyy-MM-dd') : null
      const endDate = (this.customDateRange[1]) ? format(this.customDateRange[1], 'yyyy-MM-dd') : null

      try {
        const response = await getAdPerformance(startDate, endDate)
        this.records = response.data
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
